import ChapterNextLogoLight from "@/shared/brand/assets/chapternext/logo-wordmark-light.svg";
import OneCareerLogoLight from "@/shared/brand/assets/onecareer/logo-wordmark-light.svg";
import { type Brand, detectBrandName } from "./brand";

// Login is light-only (see index.html `color-scheme: light`), so only the
// light wordmark is rendered — no theme store, no dark variant.
const LOGOS: Record<Brand, string> = {
  onecareer: OneCareerLogoLight,
  chapternext: ChapterNextLogoLight,
};

const BRAND_LABELS: Record<Brand, string> = {
  onecareer: "OneCareer",
  chapternext: "ChapterNext",
};

/** Brand wordmark for the active (runtime-resolved) brand. */
export function BrandLogo({ className }: { className?: string }) {
  const brand = detectBrandName();
  return (
    <img src={LOGOS[brand]} alt={BRAND_LABELS[brand]} className={className} />
  );
}
